import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export function ConfirmDialog({ open, title, text, action = "Sil", onConfirm, onClose }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent className="rounded-3xl" data-testid="confirm-dialog">
        <AlertDialogHeader><AlertDialogTitle>{title}</AlertDialogTitle>{text && <AlertDialogDescription>{text}</AlertDialogDescription>}</AlertDialogHeader>
        <AlertDialogFooter><AlertDialogCancel className="rounded-xl" data-testid="confirm-dialog-cancel">Vazgeç</AlertDialogCancel>
          <AlertDialogAction className="rounded-xl bg-red-600 hover:bg-red-700" onClick={onConfirm} data-testid="confirm-dialog-ok">{action}</AlertDialogAction></AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
